export default "__VITE_ASSET__CJqoDY41__"